import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { ForgotPasswordPageStyled } from './ForgotPasswordPageStyled';
import { Button, Col, Container, Form, Image, Row } from 'react-bootstrap';

import logo from '../../images/logo_branco.png';

import { TfiSave } from 'react-icons/tfi';
import { FaArrowLeft } from 'react-icons/fa';

import { PrivateRoutes } from '../../../main/constant/RouteConstant';
import AlertComponent from '../../component/alert/AlertComponent';
import React from 'react';
import MessageConstant from '../../../main/constant/MessageConstant';

interface InputsForgotPassword {
  login: string;
}

type Props = {
  sendPassword: (params: { login: string }) => Promise<any>;
};

/**
 * ForgotPasswordPage
 * @param sendPassword
 * @constructor
 */
const ForgotPasswordPage: React.FC<Props> = ({ sendPassword }: Props) => {
  /**
   * navega pela url
   */
  let navigate = useNavigate();

  /**
   * useForm
   */
  const {
    getValues,
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<InputsForgotPassword>();

  /**
   * handleVoltar
   */
  const handleVoltar = async () => {
    navigate(PrivateRoutes.HOME);
  };

  /**
   * handleSend
   */
  const handleSend = async () => {
    await sendPassword({ login: getValues('login') });
  };

  const handleSubmitValidation = async () => {
    await handleSend();
  };

  return (
    <ForgotPasswordPageStyled>
      <AlertComponent />
      <Container fluid className="container-header text-center">
        <div className="imagen">
          <Image src={logo} width={200} />
        </div>
      </Container>
      <Container className="container-field">
        <Form onSubmit={handleSubmit(handleSubmitValidation)}>
          <h3 className="text-center">Esqueci minha senha</h3>
          <Row className="justify-content-center row-field mt-3">
            <Col xs={12} md={8} lg={6}>
              <Form.Control
                placeholder="Login"
                {...register('login', {
                  required: MessageConstant.validacao.campoObrigatorio,
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: 'Por favor, insira um email válido',
                  },
                })}
              />
              {errors.login && <span className="text-danger">{errors.login.message}</span>}
            </Col>
          </Row>
          <Row className="justify-content-center mt-3">
            <Col xs={6} md={4} lg={3} className="d-flex justify-content-around">
              <Button size="sm" type="submit" className="btn-submit">
                <TfiSave width={20} style={{ paddingRight: '5px' }} />
                Enviar
              </Button>
              <Button size="sm" variant="outline-primary" onClick={handleVoltar}>
                <FaArrowLeft width={20} style={{ paddingRight: '5px' }} />
                Voltar
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </ForgotPasswordPageStyled>
  );
};

export default ForgotPasswordPage;
